<div class="widget-container">
  @if (widgetData().length > 0) {
    <mat-chip-set [attr.aria-label]="'DIARY.pulsantiera' | translate">
      @for (categoria of widgetData(); track categoria; let fgIndex = $index) {
        <mat-chip
          role="button"
          [class.orange-chips]="fgIndex === 1 || fgIndex === 5"
          [class.green-chips]="fgIndex % 2 === 0"
          [class.blue-chips]="fgIndex % 3 === 0"
          [attr.aria-label]="'CHIPS.' + categoria | translate"
          (click)="gotTo(categoria)"
        >{{ 'CHIPS.' + categoria | translate }}</mat-chip>
      }
    </mat-chip-set>
  } @else {
    <div class="flex items-center justify-center h-full py-8 text-gray-500">
      <p class="m-0 text-sm">{{ 'GENERAL.no_results_found' | translate }}</p>
    </div>
  }
</div>